import Button from "app/components/Button";
import clsx from "clsx";
import React, { ComponentProps, FC } from "react";
import BillableSwitch from "./BillableSwitch";

export const BillableSection: FC<{
  saveButtonProps?: ComponentProps<
    {
      children?: React.ReactNode;
    } & typeof Button
  >;
  showSaveButton?: boolean;
  className?: string;
  billableSwitchProps: ComponentProps<typeof BillableSwitch>;
}> = ({
  saveButtonProps,
  showSaveButton = true,
  className,
  billableSwitchProps,
}) => {
  return (
    <div
      className={clsx(
        "flex items-center justify-between gap-2.5 px-4 py-2.5 bg-gray-400 border border-gray-100 border-t-0 rounded-b",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <BillableSwitch {...billableSwitchProps} />

        <span
          className={clsx(
            "text-sm",
            billableSwitchProps.checked ? "text-black" : "text-secondary",
          )}
        >
          Billable hours
        </span>
      </div>

      {showSaveButton ? (
        <Button
          {...saveButtonProps}
          className={clsx(
            "px-6 py-2.5 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 disabled:bg-primary/20",
            saveButtonProps?.className,
          )}
        >
          {saveButtonProps?.children}
        </Button>
      ) : null}
    </div>
  );
};
